(() => {
  const sent = new Set();

  const markOnce = (key) => {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (error) {
      if (sent.has(key)) return false;
      sent.add(key);
      return true;
    }
  };

  const sendLead = (source) => {
    const key = `aloe-lead:${window.location.pathname}:${source}`;
    if (!markOnce(key)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'aloe_quote_success',
      lead_source: source,
      page_path: window.location.pathname,
    });

    let attempts = 0;
    const sendToMeta = () => {
      attempts += 1;
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'aloe_quote_success', { source });
        window.fbq('track', 'Lead', {
          content_name: 'Angebotsanfrage',
          content_category: 'Teamtextilien',
          currency: 'EUR',
          value: 0,
        });
        return;
      }
      if (attempts < 20) window.setTimeout(sendToMeta, 500);
    };
    sendToMeta();
  };

  if (document.querySelector('[data-aloe-lead-success]')) sendLead('contact_form');

  if (window.location.pathname.startsWith('/apps/request-quote')) {
    const successText = /vielen dank|erfolgreich|successfully|anfrage.{0,30}(gesendet|eingegangen)|angebot.{0,30}angefragt/i;
    const checkSuccess = () => {
      const text = document.body?.innerText || '';
      const locationText = `${window.location.search}${window.location.hash}`;
      if (successText.test(text) || /confirm|success|thank/i.test(locationText)) sendLead('quick_quote');
    };

    new MutationObserver(checkSuccess).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    checkSuccess();
  }
})();
